import { UserInfoResDTO } from '@/services/permission'

export interface AppState {
  userInfo: UserInfoResDTO
}

export default {
  namespaced: true,
  state: {
    userInfo: null
  },
  mutations: {
    setUserInfo(state: AppState, userInfo: UserInfoResDTO): void {
      state.userInfo = userInfo
    }
  },
  actions: {
  },
  getters: {
    userInfo: (state: AppState): UserInfoResDTO => state.userInfo
  }
}
